import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Equipment } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService extends BaseApiService<Equipment> {
  get cacheKey(): StorageKey {
    return StorageKey.equipmentServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/equipments`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected parse(obj) {
    return Equipment.parse(obj);
  }

  protected unparse(obj) {
    return Equipment.unparse(obj);
  }
}
